<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <yin-yang-chart
        :data-list="dataList"
        :unit-prop="unitProp"
        :download-name="downloadName"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import YinYangChart, {ALL_YIN_YANG_FACTOR_IDS_REGEXP} from '../../../../components/Data/YinYangChart'

export default {
  name: 'StatisticalAnalysisYinYangIon',
  routeInfo: {
    label: '阴阳离子平衡',
    icon: 'fa fa-eye'
  },
  extends: BaseSiteFactorData,
  data () {
    return {
      query: {
        factorIds: [],
        isMultipleIntegral: true
      }
    }
  },
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, YinYangChart},
  computed: {
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.ION_DEVICE_CATEGORY, true, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => ALL_YIN_YANG_FACTOR_IDS_REGEXP.test(siteDeviceFactor.factorId)))
    ],
    downloadName: () => '阴阳离子平衡'
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      let siteId = dimensionIds[dimension]

      return {
        type: 'bar',
        stack: siteId,
        barMaxWidth: 30,
        showSymbol: false,
        areaStyle: {}
      }
    },
    getSelectedNames (dimension, params) {
      return dimension === 0 ? Object.values(params[dimension ^ 1]).reduce((map, config) => {
        let configName = config.name
        map[configName] = /_P$/i.test(configName)

        return map
      }, {}) : null
    }
  },
  watch: {
    filterFactorMap: {
      immediate: true,
      handler (filterFactorMap) {
        this.selectedNames = this.query.factorIds.reduce((list, factorId) => {
          let factor = filterFactorMap[factorId]

          if (factor && !/_P$/i.test(factor.id)) {
            list.push(factor.name)
          }

          return list
        }, [])
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/00PM/01Ion-Yin-Yang/index.vue